var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-breadcrumb", {
        attrs: { name: "CTS Driver & Vehicle Upload" },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12", lg: "8" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Upload CTS Driver & Vehicle Information",
                    "sub-title": "Upload the latest CTS fleet workbook.",
                    "with-footer": "",
                    "second-body": !!_vm.importResult,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                variant: "primary",
                                disabled:
                                  _vm.formState.processing || !_vm.form.file,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.submitFleet.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Upload Driver & Vehicle Information\n            "
                              ),
                              _vm.formState.processing
                                ? _c("b-spinner", {
                                    staticClass: "ml-1",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "second-body",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-wrap justify-content-between align-items-center mb-3",
                            },
                            [
                              _c("div", [
                                _c("h5", { staticClass: "mb-1" }, [
                                  _vm._v("Latest Import"),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-muted mb-0" }, [
                                  _vm._v(
                                    "Driver and vehicle information imported successfully."
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-badge", { attrs: { variant: "success" } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.importResult.drivers_imported) +
                                    " drivers, " +
                                    _vm._s(_vm.importResult.vehicles_imported) +
                                    " vehicles\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Drivers Created"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.importResult.drivers_created)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Drivers Updated"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.importResult.drivers_updated)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Vehicles Created"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.importResult.vehicles_created)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Vehicles Updated"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.importResult.vehicles_updated)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Drivers Deactivated"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.importResult.drivers_deactivated)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6", md: "3" } }, [
                                _c("div", { staticClass: "summary-label" }, [
                                  _vm._v("Vehicles Deactivated"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.importResult.vehicles_deactivated
                                    )
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _vm._v(
                      "\n          Drivers and vehicles missing from the workbook will be marked inactive.\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submitFleet.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-for": "cts-fleet-file",
                            "invalid-feedback": _vm.validation.file,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n              Driver & Vehicle Workbook "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "required-asterisk" },
                                    [_vm._v("*")]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("b-form-file", {
                            attrs: {
                              id: "cts-fleet-file",
                              state: _vm.fieldState("file"),
                              placeholder:
                                "Choose the CTS driver and vehicle workbook or drop it here",
                              "drop-placeholder": "Drop workbook here",
                              accept:
                                ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            },
                            model: {
                              value: _vm.form.file,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "file", $$v)
                              },
                              expression: "form.file",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }